var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { Button, ButtonIcon, Card, CardBody, CardFooter, CardHeader, Col, COLORS, FormComponent, Row, } from 'grilnica-reactstrap';
import { mdiArrowLeft } from '@mdi/js';
import { connectComponent } from '../redux/utils';
var CardForm = /** @class */ (function (_super) {
    __extends(CardForm, _super);
    function CardForm(props) {
        var _this = _super.call(this, props) || this;
        _this.handleSubmit = function () { return __awaiter(_this, void 0, void 0, function () {
            var onSubmit;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        onSubmit = this.props.onSubmit;
                        return [4 /*yield*/, onSubmit()];
                    case 1:
                        _a.sent();
                        this.goBack();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.goBack = function () {
            var history = _this.props.history;
            history.goBack();
        };
        _this.isSubmitDisabled = function () {
            return _this.state.isSendingRequest || _this.props.isSubmitDisabled;
        };
        _this.state = {};
        return _this;
    }
    CardForm.prototype.render = function () {
        var _this = this;
        var _a = this.props, title = _a.title, children = _a.children, isPaddingForButton = _a.isPaddingForButton;
        return (React.createElement("form", { onSubmit: this.onSubmit },
            React.createElement(Card, null,
                React.createElement(CardHeader, { isPaddingForButton: isPaddingForButton },
                    React.createElement(ButtonIcon, { size: 'md', iconPath: mdiArrowLeft, color: COLORS.gray600, title: 'Назад', className: 'mr-x2', onClick: function () {
                            _this.goBack();
                        } }),
                    title),
                React.createElement(CardBody, null,
                    children,
                    React.createElement(Row, null,
                        React.createElement(Col, { xs: 9 }, this.getErrorFormFeedback('m-secondary')))),
                React.createElement(CardFooter, null,
                    React.createElement(Button, { size: 'sm', type: 'button', color: 'primary', outline: true, className: 'mr-primary', onClick: function () {
                            _this.goBack();
                        } }, "\u041E\u0442\u043C\u0435\u043D\u0430"),
                    React.createElement(Button, { type: 'submit', color: 'primary', disabled: this.isSubmitDisabled(), size: 'sm' }, "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C")))));
    };
    return CardForm;
}(FormComponent));
export default connectComponent(function (state, props) { return ({ history: props.history }); }, function () { return ({}); }, CardForm);
//# sourceMappingURL=CardForm.js.map